import {
  HEX,
  SCALING,
  Targeting
} from "../../../src";
import { SEC } from "../../../src";
import { MELEE_WINDUP } from "../../../src/actions/impacts";
const vampiric_touch = {
  slug: "vampiric_touch",
  name: "Vampiric Touch",
  abilityIcon: "vampiric_touch",
  description: "Sear a foe with shadow, draining their essence to heal yourself.",
  costs: [{ stat: "mana", value: 12 }],
  targeting: Targeting.MeleeAttack,
  cooldown: SEC(4),
  windup: MELEE_WINDUP,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "siphon",
              scalingFactors: SCALING.SHADOW_TOUCH,
              transferRatio: 0.5
            }
          ]
        }
      }
    ]
  },
  tags: ["spell", "melee", "black"]
};
export {
  vampiric_touch
};
//# sourceMappingURL=data:application/json;base64,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
